<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>

  <div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
  </div>
</div>
<div class="Content_outer">
  <div style="margin: 10px; float: right">{{ updated_at }}</div>
  <!-- <div class="legendbox" style="margin: 10px;">
        <div style="background-color:#999999"></div><strong>Offline</strong>
        <div style="background-color:#72FF13"></div><strong>Healthy/OFF</strong>
        <div style="background-color:#FAA700"></div><strong>Unsatisfactory</strong>
        <div style="background-color:#ff2a1b"></div><strong>Unacceptable/ON</strong>
    </div> -->

  <div class="inner_gauge_box">
    <div
      class="chart_boxes_outer_V2 m_b_0 vibrationChartsView"
      style="padding: 0px 10px"
    >
      <div class="ch_box temp col-md-6">
        <button
          style="float: right"
          mat-button
          (click)="openEboilerThresholdSetting('boilerParameters')"
          class="border border-light settings-icon"
        >
          <img
            style="width: 20px; height: 20px; cursor: pointer"
            src="./assets/settings.png"
          />
        </button>
        <div class="heading">Boiler Parameters</div>

        <div
          class="inner tempInner"
          *ngIf="boilerPramStatusLoading; else boilerStatusId"
        >
          <div class="cht" *ngFor="let i of [0, 1, 2]">
            <ng-container>
              <div class="spinner-container">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
            </ng-container>
          </div>
        </div>
        <ng-template #boilerStatusId>
          <div class="inner tempInner">
            <div
              class="cht boiler-chart"
              *ngFor="let meterdata1 of eboilerParametersGuageData"
            >
              <app-gauge-chart
                [matTooltip]="
                  meterdata1.name + ' as per customer defined threshold value.'
                "
                style="color: orange"
                [matTooltipClass]="'tooltip'"
                [ngClass]="{
                  big_font_chartbox: meterdata1.hasneedle == false
                }"
                [canvasWidth]="160"
                [canvasHeight]="160"
                [needleValue]="meterdata1.needleValue"
                [needleColor]="meterdata1.options.needleColor"
                [options]="meterdata1.options"
                [name]="meterdata1.name"
                [bottomLabel]="meterdata1.bottomLabel"
              >
              </app-gauge-chart>
            </div>
          </div>
        </ng-template>
      </div>

      <div class="ch_box digitalStatusMain col-md-3 p-5">
        <app-eboiler-bar-chart class="windTemp d-block"></app-eboiler-bar-chart>
      </div>
      <div class="ch_box center" (click)="getMoreParameter()">
        <img class="additional-img" src="./assets/arrow 1.png" alt="" />
        <button class="more-parameters">Additional Boiler Parameters</button>
      </div>
    </div>

    <div class="section">
      <div class="sectionHeading" style="text-align: center">Trend Graphs</div>
      <div class="summary_boxes_outer">
        <div class="summaryBox">
          <ng-container *ngIf="waterLevelloading; else waterLevelid">
            <div class="spinner-container charts-loader">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
          </ng-container>
          <ng-template #waterLevelid>
            <app-line-chart
              *ngIf="waterLevelChartData && waterLevelChartData.length > 0"
              [chartContainerId]="'get-trends-water-level'"
              [chartData]="waterLevelChartData[0]"
              [movingAvgData]="watermovingAvg"
              [chartOptions]="waterLevelChartOptions"
              [chartBgColors]="waterLevelChartColors[0]"
              class="windTemp"
            >
            </app-line-chart>
          </ng-template>
        </div>

        <div class="summaryBox">
          <ng-container *ngIf="firingRateloading; else firingRateid">
            <div class="spinner-container charts-loader">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
          </ng-container>
          <ng-template #firingRateid>
            <app-line-chart
              *ngIf="firingRateChartData && firingRateChartData.length > 0"
              [chartContainerId]="'get-trends-firing-rate'"
              [chartData]="firingRateChartData[0]"
              [movingAvgData]="firingmovingAvg"
              [chartOptions]="firingRateChartOptions"
              [chartBgColors]="firingRateChartColors[0]"
              class="windTemp"
            >
            </app-line-chart>
          </ng-template>
        </div>

        <div class="summaryBox">
          <ng-container *ngIf="steamPressureChartloading; else steamPressureid">
            <div class="spinner-container charts-loader">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
          </ng-container>

          <ng-template #steamPressureid>
            <app-line-chart
              *ngIf="
                steamPressureChartData && steamPressureChartData.length > 0
              "
              [chartContainerId]="'get-trends-steam-pressure'"
              [chartData]="steamPressureChartData[0]"
              [movingAvgData]="steammovingAvg"
              [chartOptions]="steamPressureChartOptions"
              [chartBgColors]="steamPressureChartColors[0]"
              class="windTemp"
            >
            </app-line-chart>
          </ng-template>
        </div>

        <div class="summaryBox">
          <ng-container *ngIf="burnerStatusloading; else burnerStatusid">
            <div class="spinner-container charts-loader">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
          </ng-container>
          <ng-template #burnerStatusid>
            <app-line-chart
              *ngIf="burnerStatusChartData && burnerStatusChartData.length > 0"
              [chartContainerId]="'get-trends-burner-status'"
              [chartData]="burnerStatusChartData[0]"
              [chartOptions]="burnerStatusChartOptions"
              [chartBgColors]="burnerStatusChartColors[0]"
              class="windTemp"
            >
            </app-line-chart>
          </ng-template>
        </div>

        <div class="summaryBox">
          <ng-container *ngIf="commonAlarmloading; else commonAlarmid">
            <div class="spinner-container charts-loader">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
          </ng-container>
          <ng-template #commonAlarmid>
            <app-line-chart
              *ngIf="commonAlarmChartData && commonAlarmChartData.length > 0"
              [chartContainerId]="'get-trends-common-alarm'"
              [chartData]="commonAlarmChartData[0]"
              [chartOptions]="commonAlarmChartOptions"
              [chartBgColors]="commonAlarmChartColors[0]"
              class="windTemp"
            >
            </app-line-chart>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="modal-background">
      <div class="model"></div>
    </div>
    <div
      class="spinner-container"
      *ngIf="loader"
      style="
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
      "
    >
      <!-- <div class="spinner-border text-primary" role="status"></div> -->
    </div>
  </div>
</div>
